




































import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import { Component, Vue } from "vue-property-decorator";
import { EducationCasesService } from "@/zh-website/src/views/Colleges/Education/service";
@Component({
  components: {
    Banner
  }
})
export default class Details extends Vue {
  id = "";
  title = "";
  nav = [];
  con = { field1: "", content2: "" };
  activeIndex = 1;
  list = {
    style: {
      "background-image": `url(${require("@/zh-website/src/assets/teach_banner.jpg")})`,
      height: "493px"
    },
    font1: "教育合作",
    font2: "",
    font3: "",
    font4: "产教科融合 与生态圈共赢",
    font5: "",
    button: ""
  };
  mounted() {
    this.getCaseDetail(this.$route.params.id);
  }
  getCaseDetail(id) {
    //调用详情接口
    EducationCasesService.getCaseDetail({ cooperationId: id }).then(
      (res: any) => {
        res.data.dynamicProgressList.forEach((item: any) => {
          if (item.id == this.$route.params.aid) {
            this.list.style["background-image"] = `url(${item.resourceUrl})`;
            //
            this.con.field1 = item.title;
            this.con.content2 = item.content;
          }
        });
      }
    );
  }
}
